// The quiz pickers that link a quiz to course content (Add New Content, the course page's Add Content
// Item, Course Builder) list only quizzes with questions: a quiz without any (e.g. a draft saved
// empty) shows children "No questions found". Quiz Management still lists every quiz.

// Query params asking GET /api/v2/lms/admin/quizzes for quizzes with questions only.
export const QUIZ_PICKER_PARAMS = { hasQuestions: true };

export const hasQuestions = (quiz) => Array.isArray(quiz?.questions) && quiz.questions.length > 0;

// The list as a picker shows it (also when the server sends every quiz).
export const quizzesWithQuestions = (list) => (Array.isArray(list) ? list.filter(hasQuestions) : []);
